import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=32962858&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=ts&"
export * from "./UserSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=32962858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32962858",
  null
  
)

export default component.exports